import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { getMsalConfig } from "./msalConfig";

export const msalInstance = new PublicClientApplication(getMsalConfig());

let initializePromise;

export function initializeMsal() {
  if (!initializePromise) {
    initializePromise = msalInstance.initialize().then(() => {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
        msalInstance.setActiveAccount(accounts[0]);
      }

      msalInstance.addEventCallback((event) => {
        if (
          event.eventType === EventType.LOGIN_SUCCESS &&
          event.payload?.account
        ) {
          msalInstance.setActiveAccount(event.payload.account);
        }
      });
    });
  }

  return initializePromise;
}
